import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  href?: string;
  className?: string;
  children?: React.ReactNode;
  trackEvent?: string;
}
export function CTAButton({
  href = '#offer',
  className = '',
  children = '¡QUIERO MI COPIA DE LONCHERA REALISTA 15-MIN AHORA!',
  trackEvent
}: CTAButtonProps) {
  return <motion.a href={href} onClick={() => {
    if (trackEvent && (window as any).fbq) {
      if (trackEvent === 'InitiateCheckout') {
        (window as any).fbq('track', 'InitiateCheckout');
      } else {
        (window as any).fbq('trackCustom', trackEvent);
      }
    }
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(231,111,81,0)', '0px 0px 20px rgba(231,111,81,0.6)', '0px 0px 0px rgba(231,111,81,0)']
  }} transition={{
    duration: 2.5,
    repeat: Infinity
  }} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`inline-block bg-[#E76F51] text-white font-bold text-center py-4 px-8 rounded-full transition-colors hover:bg-[#d65d40] shadow-lg ${className}`} data-id="element-2">
      {children}
    </motion.a>;
}